document.documentElement.classList.remove('no-js');

class RogMobileMenu {
  constructor(header) {
    this.header = header;
    this.toggle = header.querySelector('[data-rog-menu-toggle]');
    this.menu = header.querySelector('[data-rog-mobile-menu]');
    if (!this.toggle || !this.menu) return;

    this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
    this.menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) this.setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.setOpen(false, true);
    });
    window.matchMedia('(min-width: 681px)').addEventListener('change', (event) => {
      if (event.matches) this.setOpen(false);
    });
  }

  setOpen(isOpen, returnFocus = false) {
    this.toggle.setAttribute('aria-expanded', String(isOpen));
    this.toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    this.menu.classList.toggle('is-open', isOpen);
    this.header.classList.toggle('is-menu-open', isOpen);
    if (returnFocus && !isOpen) this.toggle.focus();
  }
}

document.querySelectorAll('.rog-header').forEach((header) => new RogMobileMenu(header));

class RogProductForm {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('form[action*="/cart/add"]');
    this.variantInput = root.querySelector('[name="id"]');
    this.price = root.querySelector('[data-product-price]');
    this.addButton = root.querySelector('[data-add-to-cart]');
    this.variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    this.currency = root.dataset.currency || '${{amount}}';

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-product-option]')) this.updateVariant();
    });
  }

  selectedOptions() {
    return [...this.root.querySelectorAll('[data-option-group]')].map((group) => {
      return group.querySelector('[data-product-option]:checked')?.value;
    });
  }

  updateVariant() {
    const selected = this.selectedOptions();
    const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));

    if (!variant) {
      this.addButton.disabled = true;
      this.addButton.textContent = 'Unavailable';
      return;
    }

    this.variantInput.value = variant.id;
    this.price.textContent = this.formatMoney(variant.price);
    this.addButton.disabled = !variant.available;
    this.addButton.textContent = variant.available ? `Add this reminder to my bag · ${this.formatMoney(variant.price)}` : 'Sold out';

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: this.root.dataset.shopCurrency
    }).format(cents / 100);
  }
}

document.querySelectorAll('[data-rog-product]').forEach((root) => new RogProductForm(root));
